/* eslint-disable no-param-reassign */
import getCache from '../../cache/helpers/getCache';
import omit from 'lodash/omit';

export default (modal) => {
  const notificationsCache = getCache('notifications');
  const modalsByIdCache = getCache('notificationsModalsById');
  let { modals } = notificationsCache.data;
  const model = modal.model || {};
  const id = modal.id ?? model.id ?? `modal-${modals.length}`;
  const setType = 'extend';

  modal.id = id;
  notificationsCache.set({ modals: [...modals, modal] }, { setType });
  modalsByIdCache.set({ [id]: model }, { setType });

  const promise = new Promise(((resolve) => {
    modal.commitAction = (action) => {
      const modalsById = getCache('notificationsModalsById').data;

      ({ modals } = getCache('notifications').data);
      notificationsCache.set({ modals: modals.slice(0, modals.length - 1) }, { setType });
      modalsByIdCache.set(omit(modalsById, id));
      resolve(action);
    };
  }));

  return promise;
};
